/* unplugin-vue-components disabled */import script from "./dep-cate-list.vue?vue&type=script&setup=true&lang=js"
export * from "./dep-cate-list.vue?vue&type=script&setup=true&lang=js"

import "./dep-cate-list.vue?vue&type=style&index=0&id=099425a4&lang=less"

const __exports__ = script;

export default __exports__